import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import firebase from 'firebase/app';
import { Image, Row, Col, Card, Skeleton, Button } from 'antd';

import img_elStrikeLogoImage_dark from '../../images/strikepay_Mark_url_RGB_White_small.png';


import 'antd/dist/antd.css';
import '../../App.scss';

const baseUrl = (window.location.hostname === 'localhost') ? 'http://localhost:8088' : 'https://pay.strikepay.co';

function modifyURL(url) {
  // Parse the URL using the URL constructor
  let urlObj = new URL(url);

  // Replace "/tags" with "/qr" in the pathname
  urlObj.pathname = urlObj.pathname.replace('/tags', '/qr');

  // Insert "/png" at the end of the path but before the query marker
  urlObj.pathname = urlObj.pathname.endsWith('/') ? `${urlObj.pathname}png` : `${urlObj.pathname}/png`;

  if (urlObj.port === '3000') {
    urlObj.port = '8088';
  }

  let modifiedURL = urlObj.toString();

  // Remove any trailing '?'
  if (modifiedURL.endsWith('?')) {
      modifiedURL = modifiedURL.slice(0, -1);
  }

  // Return the modified URL
  return modifiedURL;
}

function makeUrlForImage(tag, targetUrl) {
  let url = '';

  if (targetUrl) {
    url = modifyURL(targetUrl);
    return url;
  }


  const { tagId, templateTagId, tagUid } = tag;
  
  if (templateTagId && tagUid) {
    url = `${baseUrl}/qr/${templateTagId}/png?qr=${tagUid}`;
  } else {
    url = `${baseUrl}/qr/${tagId}/png`;
  }
  return url;
}

function makeUrlForButton(tag, targetUrl) {
  let url = '';

  if (targetUrl) {
    return url;
  }

  const { tagId, templateTagId, tagUid } = tag;

  if (templateTagId && tagUid) {
    url = `${baseUrl}/tags/${templateTagId}?qr=${tagUid}`;
  } else {
    url = `${baseUrl}/tags/${tagId}`;
  }
  return url;
}

export default class QRImageView extends Component {

  // Properties used by this component:
  // profileBio, displayName, avatar

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      imageData: null,
      productURL: null,
      tagId: props.tagId,
      tag: props.tag,
    };
  }

  componentDidMount() {
    this.waitForQRImageData();
  }

  waitForQRImageData = () => {
    if(this.props.tag || this.props.url) {
      this.setState({
        loading: false
      });  
      return;
    }

    this.setState({
      loading: true
    });
    const db = firebase.firestore();
    // console.log('getImageData for ', this.props.tagId);
    const doc = db.collection('QRs').doc(this.props.tagId);
    this.unsubscribe = doc.onSnapshot(snap => {
      if (snap.exists) {
        // console.log(`waitForQRImageData -- doc ${snap.data()}`);
        const data = snap.data();
        const { imageData, product, productURL, status } = data;
        if (status && status === 'generated') {
          this.unsubscribe();
          this.setState({
            imageData,
            productURL,
            product,
            status,
            loading: false
          });
        }
      }
    }, err => {
      console.log(`waitForQRImageData -- error ${err}`);
      this.setState({ loading: false, errorText: err.message, error: true });
      this.unsubscribe();
    });

  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
  }

  render() {

    const { style, size } = this.props;
    const qrImageSize = size ?? 200;
    const scale = qrImageSize / 200;
    const outerSize = Math.round(220 * scale);
    const innerImageSize = Math.round(190 * scale);
    const logoSize = Math.round(60 * scale);
    const logoOffset = Math.round((innerImageSize - logoSize) / 2);

    const view_style = {
      marginTop:'12px',
      marginLeft: 'auto',
      marginRight: 'auto',
    };

    const style_elSquareimage = {
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundColor: 'transparent',
      borderRadius: 8,
      borderColor: 'green',
      paddingTop: '2px',
    };

    const style_elSquareInner = {
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundColor: 'transparent',
      borderRadius: 8,
      borderColor: 'green',
      paddingTop: '2px',
    };

    const style_elCol = {
      marginTop: '12px',
      marginBottom: '2px',
      width: qrImageSize,
      backgroundColor: 'transparent',
      alignText: 'center',
    };

    const innerQRSize = qrImageSize - Math.round(20 * scale);
    const loadingStyle = { width: innerQRSize, height: innerQRSize };

    const { imageData, productURL, loading, error } = this.state;

    const { tagId, tag, url } = this.props;
    tag.tagId = tagId || tagId.id;
    const imgUrl = tag ? makeUrlForImage(tag, url) : null;
    const buttonUrl = tag ? makeUrlForButton(tag, url) : url;

    return (
        <div className="QRImageView" style={view_style}>
          <Row id="qr-block" style={{ width: outerSize, marginLeft: 'auto',
                        marginRight: 'auto' }} justify="center" align="top" gutter={0}>
            <Col id="qr-image-overlay" span={24} justify="center" align="middle"   >
              <div style={{ width: outerSize, height: outerSize, paddingTop: '2px', marginLeft: 'auto', marginRight: 'auto' }}>
                <div style={style_elCol}>
                  { !loading && !error ?
                    <div style={{ 
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      width: innerImageSize, height: innerImageSize,
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}>
                      <Image width={innerImageSize} src={imgUrl || imageData} alt={productURL} />
                      <img
                        width={logoSize}
                        height={logoSize}
                        src={img_elStrikeLogoImage_dark}
                        alt=""
                        style={{
                          position: 'absolute',
                          top: logoOffset,
                          left: logoOffset,
                        }}
                      />
                    </div>
                    :
                    <Skeleton.Image active style={loadingStyle} />
                  }
                </div>
              </div>
            </Col>
          </Row>
        {this.props.showButton && !loading && !error && buttonUrl &&
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Button key='confirm' type={'primary'} href={buttonUrl}>
              {`Try it!`}
            </Button>
            <div className="copyableBlock">
              <span>Tap to copy link</span>
              <CopyToClipboard
                text={buttonUrl}
                onCopy={() => {
                  this.setState({ linkCopied: !this.state.linkCopied });
                }}
              >
                <button className="promoCopyable">{this.state.linkCopied ? 'Copy Link Again' : 'Copy Link'}</button>
              </CopyToClipboard>
            </div>
            <p style={{ fontSize: '11px', fontStyle: 'italic' }}>
              {`${buttonUrl}`}
            </p>
          </div>
        }
        </div>
    );
  }

}
